module.exports = __webpack_public_path__ + "img/moneyConfirmed.c57876fd.svg";